import Swiper, {Pagination, EffectFade} from 'swiper';

import {Component} from '@lib/Component';
import {MediaQuery} from '@services/MediaQuery';

export class Environment extends Component {
  swiper: Swiper | null = null;
  pagination: HTMLDivElement[] = [];
  close: HTMLDivElement[] = [];
  mq: MediaQuery | null = null;
  outer: HTMLDivElement | null = null;

  constructor() {
    super();
    this.mq = MediaQuery.create();

    this.onClose = this.onClose.bind(this);
    this.onSlide = this.onSlide.bind(this);
  }

  onClose() {
    this.swiper?.slideTo(0);
  }

  onSlide(index: number) {
    this.pagination.map((link) => {
      link.classList.remove('active');
    });
    this.pagination.at(index - 1)?.classList.add('active');

    this.outer?.classList.remove('active');
    if (index > 0) {
      this.outer?.classList.add('active');
    }
  }

  didMount() {
    if (this.element) {
      this.outer = this.element.querySelector('.s-environment_labels');
      this.close = [
        ...this.element.querySelectorAll('.s-environment_close'),
      ] as HTMLDivElement[];

      this.close?.map((c) => {
        c.addEventListener('click', this.onClose);
      });
      this.pagination = [
        ...this.element.querySelectorAll('.s-environment_label'),
      ] as HTMLDivElement[];

      this.pagination.map((link, index) => {
        link.addEventListener('click', () => {
          this.swiper?.slideTo(index + 1);
          this.onSlide(index + 1);
          // this.pagination.map((link) => {
          //   link.classList.remove('active');
          // });
          // this.pagination.at(index)?.classList.add('active');
        });
      });

      this.swiper = new Swiper(this.element, {
        allowTouchMove: false,
        autoHeight: true,
        effect: 'fade',
        fadeEffect: {
          crossFade: true,
        },
        modules: [Pagination, EffectFade],
        on: {
          slideChange: (swiper) => {
            this.onSlide(swiper.activeIndex);
          },
        },
      });
    }
  }

  didUnmount() {
    this.close?.map((c) => {
      c.removeEventListener('click', this.onClose);
    });
    // TODO: remove event listener
    this.swiper?.destroy();
  }
}
